<template>
  <div>
    <template v-if="this.currentStepName == 'travellers'">
      <div class="price-breakdown">
        <table class="price-breakdown__table">
          <template v-if="this.isDonationPerPassanger">
            <tbody class="donation-block" v-for="room in completedRooms">
              <tr v-if="room == completedRooms[0]">
                <th colspan="2">You are turning travel into impact with a Planeterra donation</th>
              </tr>
              <tr v-if="room == completedRooms[0]">
                <td>
                  <small v-html="data.donations.label"></small>
                </td>              
              </tr>
              <tr v-for="passenger in room.passengers">            
                  <td v-if="getPassengerName(passenger) != ''" align="left">
                    <input :class="{ 'checkbox_ts': data.brandNameFormatted === Brand.Travelsphere }" type="checkbox" @click="travellerDonate(passenger)" :checked="didPassangerDonate(passenger)">
                    <span>{{getPassengerName(passenger)}}</span>              
                  </td>
                  <td v-if="getPassengerName(passenger) != '' && !passenger.donated" align="right">
                    {{ currency(donationsData.price) }}
                  </td>
              </tr>
            </tbody>
          </template>

          <template v-if="this.isDonationPerBooking">
            <tbody>
              <tr>
                <th colspan="2">Turning travel into Impact - voluntary donation to Planeterra</th>
              </tr>  
              <tr>
                <td>
                  <small>If you do not wish to make this donation, please untick the box below</small>
                </td>              
              </tr>          
              <tr>            
                  <td align="left">
                    <input type="checkbox" @click="bookingDonate()" :checked="donatedForEntireBooking()">
                    <span>{{ this.donationData.name }}</span>              
                  </td>
                  <td align="right">
                    {{ currency(donationsData.price) }}
                  </td>
              </tr>
            </tbody>
          </template>
        </table>
      </div>
    </template>

    <div class="price-breakdown-wrapper">
      <div class="price-breakdown">
        <h2 class="price-breakdown__title">Price Breakdown</h2>

        <div v-if="subtotalMismatch" class="error-message error-message--grey">
          <div class="error-message__icon"></div>
          <div class="error-message__text" v-html="data.priceBreakdown.subtotalMismatchHtml"></div>
        </div>

        <table class="price-breakdown__table">
          <tbody>
            <tr>
              <th colspan="2">Holidays and Add-Ons</th>
            </tr>
            <tr>
              <td colspan="2">{{data.tourName}}</td>
            </tr>
            <tr>  
              <td
                colspan="2"
                v-if="!departureDetails.departureLegs.length"
              >From {{departureDetails.departureNoFlights.location}} on {{departureDetails.departureNoFlights.date}}</td>
              <td
                colspan="2"
                v-else
              >From {{departureDetails.departureLegs[0].departureAirport.name}} on {{departureDetails.departureLegs[0].departureTime.date}}</td>
            </tr>
          </tbody>

          <tbody v-for="room in completedRooms" :key="room.key">
            <tr>
              <th colspan="2">Room type: {{room.name}}</th>
            </tr>
            <tr v-for="passenger in room.passengers" :key="passenger.key">
              <td>{{getPassengerName(passenger)}}</td>
              <td align="right">
                <span v-if="!subtotalMismatch">{{currency(room.pricePerPerson)}}</span>
              </td>
            </tr>
          </tbody>

          <template v-if="this.currentStepName == 'travellers'">
            <template v-if="this.isDonationPerPassanger">
              <tbody>
                <template v-if="anyPassangerDonated">
                  <tr>
                    <th colspan="2">Turning travel into Impact - voluntary donation to Planeterra</th>
                  </tr>
                  <template v-for="room in completedRooms">
                    <tr v-for="passenger in room.passengers" v-if="didPassangerDonate(passenger)">
                      <td align="left">
                        <span>{{ getPassengerName(passenger) }}</span>
                      </td>
                      <td align="right">
                        {{ currency(donationsData.price) }}
                      </td>
                    </tr>
                  </template>
                </template>
              </tbody>
            </template>

            <template v-if="this.isDonationPerBooking">
              <tbody>
                <tr>
                  <th colspan="2">You are turning travel into impact with a Planeterra donation</th>            
                </tr>          
                <tr>            
                    <td align="left">
                      <span>{{ donationData.name }}</span>              
                    </td>
                    <td align="right">
                      {{ currency(donationsData.price) }}
                    </td>
                </tr>
              </tbody>
            </template>
          </template>

          <template v-if="this.currentStepName != 'travellers' && passangersWhoDonated.length > 0">
            <tbody>
              <tr>
                <th colspan="2">Turning travel into Impact - voluntary donation to Planeterra</th>
              </tr>
              <tr v-for="passenger in passangersWhoDonated">            
                  <td align="left">
                    <span>{{getDonatingPassengerName(passenger)}}</span>              
                  </td>
                  <td align="right">
                    {{ currency(donationsData.price) }}
                  </td>
              </tr>
            </tbody>   
          </template>

          <template v-if="this.currentStepName != 'travellers' && isDonationPerBooking">
            <tbody>
              <tr>
                <th colspan="2">You are turning travel into impact with a Planeterra donation</th>            
              </tr>          
              <tr>            
                  <td align="left">
                    <span>{{ donationData.name }}</span>              
                  </td>
                  <td align="right">
                    {{ currency(donationsData.price) }}
                  </td>
              </tr>
            </tbody>          
          </template>

          <tbody v-if="completedExcursions.length">
            <tr>
              <th colspan="2">Optional Excursions</th>
            </tr>
            <tr v-for="excursion in completedExcursions" :key="excursion.id">
              <td>{{excursion.name}}</td>
              <td align="right">
                <span
                  v-if="!subtotalMismatch"
                >{{excursion.passengers.filter(passenger => passenger.selected).length}} &times; {{currency(excursion.price)}}</span>
              </td>
            </tr>
          </tbody>

          <tbody v-if="selectedVisas.length">
            <tr>
              <th colspan="2">Optional Visas</th>
            </tr>
            <tr v-for="visa in selectedVisas" :key="visa.id">
              <td>{{visa.name}}</td>
              <td align="right">
                <span v-if="!subtotalMismatch">{{visa.count}} &times; {{currency(visa.price)}}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="subtotal-placeholder" v-if="subtotal && this.currentStepName != 'travellers'">
        <div class="subtotal subtotal--sticky">
          <div class="container-fluid">
            <div class="subtotal-inner">
              <div class="subtotal-content">
                <div class="subtotal__text"
                    :class="{ 'subtotal__text__colorTs': data.brandNameFormatted === Brand.Travelsphere }">Subtotal</div>
                <div class="subtotal__cost"
                    :class="{ 'subtotal__text__colorTs': data.brandNameFormatted === Brand.Travelsphere }">{{currency(subtotal)}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div v-if="subtotal && this.currentStepName == 'travellers'">
        <div class="subtotal">
            <div class="subtotal-inner">
              <div class="subtotal-content">
                <div class="subtotal__text"
                    :class="{ 'subtotal__text__colorTs': data.brandNameFormatted === Brand.Travelsphere }">Subtotal</div>
                <div class="subtotal__cost"
                    :class="{ 'subtotal__text__colorTs': data.brandNameFormatted === Brand.Travelsphere }">{{currency(subtotal)}}</div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import * as stickySubtotal from '@/modules/sticky-subtotal.js';
import {Brand} from './../../../../brand.js';

export default {
  props: ['usePassengerDetails'],

  data() {
    return {
      Brand
    };
  },

  computed: {
    ...mapState('checkout', [
      'rooms',
      'quote',
      'data',
      'departureDetails',
      'excursions',
      'subtotalMismatch',
      'isLoginBoxDisplayed',
      'donationsData',
      'passangers'
    ]),
    ...mapGetters('checkout', [
      'currency',
      'runningSubtotal',
      'selectedVisas',
      'passengersDetails', 
      'currentStepName',
      'donationData',
      'donatingTravellers',
      'nonDonatingTravellers',
      'donated',
      'passangersWhoDonated',
      'donationPerBooking'
    ]),
    ...mapGetters(['passengerFullName', 'formDataFlat']),

    /** only get rooms that have passenger details */
    completedRooms() {
      return this.rooms.filter(room => room.id && room.passengers.length);
    },

    /** only get excursions which have at least one passenger */
    completedExcursions() {
      return this.excursions.filter(excursion =>
        excursion.passengers.some(passenger => passenger.selected)
      );
    },

    /** donations can be made per booking and per person **/
    isDonationPerPassanger() {
      return this.currentStepName == 'travellers' && this.donationData && this.donationData.allocationType == 'PerPerson';
    },
     /** donations can be made per booking and per person **/
    isDonationPerBooking() {
      return this.currentStepName == 'travellers' && this.donationData && this.donationData.allocationType == 'PerBooking';
    },
    /** donation made **/
    donationMade() {
      return this.currentStepName != 'travellers' && this.donated;
    },

    /** visible subtotal (either runningSubtotal or quote.subtotal) */
    subtotal() {
      return this.subtotalMismatch ? this.quote.subtotal : this.runningSubtotal;
    },

    /**  Checks if there are any passengers who have made a donation */
    anyPassangerDonated() {
      return this.completedRooms.some(room => room.passengers.some(passenger => this.didPassangerDonate(passenger)));
    }
  },

  mounted() {
    stickySubtotal.init();
  },

  methods: {
    travellerDonate(passenger) {
      const passangerName = this.getPassengerName(passenger);     

      if (this.nonDonatingTravellers != undefined && this.nonDonatingTravellers.includes(passangerName)) {
        this.$store.commit("checkout/removeNonDonatingTraveller", passangerName);
      } 
      else {         
         this.$store.commit("checkout/addNonDonatingTraveller", passangerName);
      }
    },
    
    bookingDonate() {
      this.$store.commit("checkout/setBookingDonation");
    },

    didPassangerDonate(passanger) {
      return !this.nonDonatingTravellers.includes(this.getPassengerName(passanger));
    },

    donatedForEntireBooking() {
      return this.quote.donationId == null || this.donationPerBooking;
    },

    donationDescription() {
      if (!this.donationData)
        return '';
      return this.donationData.description;
    },

    donationImage() {
      if (!this.donationData)
        return '';
      return this.donationData.imageUrl;
    },

    getPassengerName(passenger) {
      if (
        this.usePassengerDetails &&
        this.passengersDetails &&
        this.passengersDetails.length &&
        !this.isLoginBoxDisplayed
      ) {
        const passengerDetails = this.passengersDetails.find(
          ({ passengerId }) => passengerId === passenger.passengerId
        );
        if (passengerDetails) {
          return `${passengerDetails.firstName} ${passengerDetails.lastName}`;
        }
      }
      return this.passengerFullName(this.formDataFlat(passenger));
    },

    getDonatingPassengerName(passenger) {
      const passengerDetails = this.passengersDetails.find(({ passengerId }) => passengerId === passenger.passengerId);

      if (passengerDetails) {
        return `${passengerDetails.firstName} ${passengerDetails.lastName}`;
      }

      return passenger.firstName + ' ' + passenger.lastName;
    }
  }
};
</script>